import { computed } from 'mobx';
import ApiModel     from './globals/ApiModel';

export default class LayoutTypeModel extends ApiModel {
  static get path() {
    return '/backend/layout_types/{?id}';
  }

  @computed
  public get label(): string {
    return this.get('label', '');
  }

  @computed
  public get color(): string {
    return this.get('color', '');
  }
}
